import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { RolDto } from '@models/seguridad/roles/rolDto.model';
import { RolService } from '@services/rol/rol.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogUpdateRolComponent } from '../actualizar-rol/dialog-update-rol/dialog-update-rol.component';
import { DialogCreateRolComponent } from '../crear-rol/dialog-create-rol/dialog-create-rol.component';
import { DialogDeleteRolComponent } from '../eliminar-rol/dialog-delete-rol/dialog-delete-rol.component';
import { DialogViewRolComponent } from '../dialog-view-rol/dialog-view-rol.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AvatarInicialesComponent } from '@component/avatar-iniciales/avatar-iniciales.component';
import { ButtonFilterTableClearComponent } from '@component/button-filter-table-clear/button-filter-table-clear.component';
import { ButtonFilterTableComponent } from '@component/button-filter-table/button-filter-table.component';
import { ButtonNewComponent } from '@component/button-new/button-new.component';
import { SelectUsuariosEmpresaComponent } from '@component/select-usuarios-empresa/select-usuarios-empresa.component';
import { SinDatosParaMostrarComponent } from '@component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { TableroKanbanComponent } from '@views/tareas/list-tarea/tablero-kanban-tareas/tableroKanban.component';

@Component({
  standalone: true,
    imports: [SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
      MatDividerModule, NgxSpinnerModule, MatTableModule,
      MatSliderModule, MatSlideToggleModule, MatMenuModule,
      MatDialogModule, MatDatepickerModule, MatExpansionModule,
      FormsModule, AppRolesDirective, MatSortModule, MatTooltipModule,
      MatPaginatorModule, MatRippleModule, CommonModule, ButtonFilterTableComponent, FormsModule, MatNativeDateModule, MatSelectModule, TableroKanbanComponent, AvatarInicialesComponent, ButtonFilterTableClearComponent, SelectUsuariosEmpresaComponent],
  selector: 'app-listado-rol',
  templateUrl: './listado-rol.component.html',
  styleUrls: ['./listado-rol.component.css']
})
export class ListadoRolComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private RolService: RolService
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['descripcion', 'accion'] :
        ['descripcion', 'accion'];
    });

  }

  data = false
  dataSource = new MatTableDataSource<RolDto>();
  obj!: undefined
  displayedColumns: string[] = [];

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }
  ngOnInit() {

  }
  filtrar(){
    this.getAllRoles();
  }

  filtrosAvanzados(event:any){}
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  openDialogCreate() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "50%"
    const dialogRef = this.dialog.open(DialogCreateRolComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Agregar) {
        this.getAllRoles();
      }
    });
  }

  openDialogUpdate(rolDto:RolDto) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "50%"
    dialogConfig.data = rolDto
    const dialogRef = this.dialog.open(DialogUpdateRolComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Modificar) {
        this.getAllRoles();
      }
    });
  }

  openDialogDelete(rolDto:RolDto) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "50%"
    dialogConfig.data = rolDto
    const dialogRef = this.dialog.open(DialogDeleteRolComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Eliminar) {
        this.getAllRoles();
      }
    });
  }

  openDialogVer(rolDto:RolDto) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = "50%"
    dialogConfig.data = rolDto
    const dialogRef = this.dialog.open(DialogViewRolComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result.event == AccionesDialog.Ver) {
        this.getAllRoles();
      }
    });
  }

  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getAllRoles() {
    this.spinner.show("spRoles")
    this.RolService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spRoles")
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide("spRoles")
          this.snackBar.showError(error, "Error");
        }
      )
  }

}
